<script>
  import { style, blocklist, text, richtext, image, url } from "../toolbox.js";
  import { link } from "svelte-routing";

  export let block;
</script>

<section style="{style(block)}" class="bg-light">
  <div class="container">
    <div class="row">
      <div class="card">
       <div class="row">
          <div class="col-lg-8">
             <div class="card-body">
                <h3 class="">{text(block, 'title')}</h3>
                <p>{text(block, 'subtitle')}</p>
                <div class="row mt-5 mb-2">
                   <div class="col-lg-3 col-12">
                      <h6 class="text-dark tet-uppercase">What&#39;s included</h6>
                   </div>
                   <div class="col-6">
                      <hr class="horizontal dark">
                   </div>
                </div>
                <div class="row">
                  {#each blocklist(block, 'features') as feature}
                  <div class="col-lg-6 col-md-6 col-12 ps-0">
                    <div class="info d-flex align-items-center p-2">
                      <div class="icon icon-shape icon-xs rounded-circle bg-gradient-info opacity-6 shadow text-center">
                        <i class="fas fa-check opacity-10"></i>
                      </div>
                      <div>
                        <span class="ps-2">{text(feature, 'text')}</span>
                      </div>
                    </div>
                  </div>
                  {/each}
                </div>
             </div>
          </div>
          <div class="col-lg-4 my-auto">
             <div class="card-body text-center">
                <h6 class="mt-4 mb-0">{text(block, 'priceTitle')}</h6>
                <h1 class="mt-0">
                  {text(block, 'price')}
                </h1>
                <a href="{url(block, 'button')}" type="button" class="btn btn-lg mt-2">
                  {text(block, 'button')}
                </a>
                <p class="text-sm">{text(block, 'tip')}</p>
             </div>
          </div>
       </div>
     </div>
    </div>
  </div>
</section>
